import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { UiAvatarComponent } from '../../atoms/avatar/avatar.component';
import { UiButtonComponent } from '../../atoms/button/button.component';
import { UiTagComponent } from '../../atoms/tag/tag.component';
import { UiPortalAccountIdentityStatus } from './portal-account-card.types';

export type { UiPortalAccountIdentityStatus };

/**
 * Organismo: tarjeta de cuenta del portal.
 *
 * Muestra avatar, nombre, estado, contacto e indicador de identidad.
 * Es presentacional: no navega ni conoce dominio.
 */
@Component({
  selector: 'ui-portal-account-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiAvatarComponent, UiButtonComponent, UiTagComponent],
  templateUrl: './portal-account-card.component.html',
  styleUrl: './portal-account-card.component.scss',
  host: { class: 'ui-portal-account-card-host' },
})
export class UiPortalAccountCardComponent {
  readonly name = input.required<string>();
  readonly avatarLabel = input.required<string>();
  readonly avatarAriaLabel = input('');
  readonly clientCode = input('');
  readonly statusLabel = input('Activo');
  readonly email = input.required<string>();
  readonly phone = input.required<string>();
  readonly emailLabel = input('Correo');
  readonly phoneLabel = input('Celular');
  readonly identityStatus = input<UiPortalAccountIdentityStatus>('pending');

  readonly identityClick = output<void>();

  protected readonly identityValidated = computed(
    () => this.identityStatus() === 'validated',
  );

  protected readonly identityLabel = computed(() =>
    this.identityValidated()
      ? 'Identidad validada'
      : 'Identidad pendiente de validar',
  );
}
